module.exports = __webpack_public_path__ + "static/media/sel_09_246.48510f3d.mp4";